import axios from 'axios';
import { LanguageTranslations } from '../types/Language';

const apiUrl = process.env.REACT_APP_API_URL;

export async function fetchLanguageTranslationsById(
  languageId: string
): Promise<LanguageTranslations> {
  const response = await axios.get(`${apiUrl}/languages/${languageId}/translations`);
  return response.data as LanguageTranslations;
}

export async function fetchLanguageTranslationsByCode(
  code: string
): Promise<LanguageTranslations> {
  const response = await axios.get(`${apiUrl}/languages/translations/${code}`);
  return response.data as LanguageTranslations;
}

export async function replaceLanguageTranslations(
  languageId: string,
  translations: LanguageTranslations
): Promise<LanguageTranslations> {
  const response = await axios.put(`${apiUrl}/languages/${languageId}/translations`, translations);
  return response.data as LanguageTranslations;
}
